// extracted by mini-css-extract-plugin
export default {"majorMinor":"ReleaseCardTitle_majorMinor__mJ-ck","patch":"ReleaseCardTitle_patch__baYzY"};